import BaseProxy from "../../../base-proxy";

/**
 * @class PendingChangeOfDirectorProxy
 * @description save data change of director when payment method is manual payment
 * @author Angelica Payawal
 * @version 1.0
 * @since Feb 5, 2021
 */
export default {
  /**
   * @async
   * @function execute
   * @param input Input parameter.
   * @param {String} input.authToken Token used for issuing authenticated request.
   * @param {Object} input.payload payload form
   */
  async createPendingRequestForChangeOfDirectorProxy(input = {}) {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/v2/sleek-workflow/change-of-director/pending-request`;

    return await baseProxy.postAuthenticatedData(endpointUrl, input.authToken, input.payload);
  },
};
